<!-- dashboard -->
<div class="contenedor">
  <div
    class="banner-container"
    style="border: 2px solid #128521; padding: 10px"
  >
    <h2>Diploma Dual®</h2>
    <p>
      El programa oficial de convalidación internacional de títulos de
      bachillerato  que permite a los alumnos obtener dos titulaciones
      simultáneas: la propia de su país y el American High School Diploma.
    </p>
    <img style="width: 40%" src="/assets/img/banner/academica.png" alt="" />
    <a
      href="https://www.academica.school/"
      target="_blank"
      class="button-banner"
      style="background-color: #128521; color: #fff"
    >
      Más información
    </a>
  </div>
  <div
    class="banner-container"
    style="border: 2px solid #128521; padding: 10px"
  >
    <img style="width: 15%" src="/assets/img/banner/university.png" alt="" />
    <h2>Academica University</h2>
    <p>Las mejores universidades están buscando a sus alumnos</p>
    <p>JORNADAS ACADEMICA UNIVERSITY AROUND THE WORLD</p>
    <p>
      Videoconferencias dirigidas a los alumnos para que
      <b>dispongan de un espacio de encuentro</b>, conocimiento, orientación,
      oportunidades y contacto <b>con la universidad y sus profesionales.</b>
    </p>
    <a
      href="https://www.academica.school/university"
      target="_blank"
      class="button-banner"
      style="background-color: #128521; color: #fff"
    >
      Más información
    </a>
  </div>
 
</div>

